<template>
    <div class="bg-dashboard-primary h-full">
        <WebinarInfo />
        <div class="grid w-full py-4" :class="gridClass">
            <!-- Left draggable list -->

            <div :class="[leftDraggable, editMode ? 'outline-4 outline-dotted outline-blue' : '']" class="rounded-xl mb-2 mx-2 min-w-0">
                <draggable
                    v-model="leftSection"
                    tag="ul"
                    group="left"
                    :animation="300"
                    :disabled="!editMode"
                    :item-key="'id'"
                    class="draggable-list h-full py-2 min-w-0"
                    @start="onStart"
                    @end="onEnd"
                >
                    <template #item="{ element }">
                        <li
                            :key="element.id"
                            :class="[
                                'rounded-xl m-4 ',
                                element.name === 'Marketing' || element.name === 'Trades' || element.name === 'Analysen'
                                    ? 'bg-transparent'
                                    : element.name === 'Zielzonen'
                                      ? 'bg-white rounded-xl'
                                      : 'bg-white p-6  rounded-xl'
                            ]"
                        >
                            <Metrics
                                v-if="element.name === 'Aktuell'"
                                class="md:p-4"
                                :heading="$t('dashboard_heading_metrics')"
                                :size="calculateSize(element.name, true)"
                                :edit-mode="editMode"
                            />
                            <CurrentPriceTargets v-if="element.name === 'Zielzonen'" />
                            <!--  <PriceTargets
                                v-if="element.name === 'Zielzonen'"
                                :heading="$t('dashboard_heading_pricetargets')"
                                :size="calculateSize(element.name, true)"
                                :edit-mode="editMode"
                            /> -->
                            <Portfolio v-if="element.name === 'Trades'" :heading="$t('dashboard_heading_trades')" :size="calculateSize(element.name, true)" :edit-mode="editMode" />
                            <!--  <ContentstreamsList
                                v-if="element.name === 'Analysen'"
                                :edit-mode="editMode"
                                :heading="$t('plain_analysis_plural')"
                                :header="true"
                                :filter-header="true"
                                :search-header="true"
                                :date-header="true"
                                :size="calculateSize(element.name, true)"
                                class="h-[500px] overflow-hidden"
                            /> -->
                            <Marketing
                                v-if="element.name === 'Marketing'"
                                :heading="$t('dashboard_heading_marketing')"
                                :size="calculateSize(element.name, true)"
                                :edit-mode="editMode"
                            />
                        </li>
                    </template>
                </draggable>
            </div>

            <!-- Right draggable list -->
            <div :class="[rightDraggable, editMode ? 'outline-4 outline-dotted outline-blue ' : '', allInOneList ? 'px-10' : '']" class="rounded-xl mb-2 mx-2 min-w-0">
                <draggable
                    v-model="rightSection"
                    tag="ul"
                    group="left"
                    :animation="300"
                    :disabled="!editMode"
                    :item-key="'id'"
                    class="draggable-list h-full py-2 min-w-0"
                    @start="onStart"
                    @end="onEnd"
                >
                    <template #item="{ element }">
                        <li :key="element.id" class="rounded-xl m-4">
                            <Metrics
                                v-if="element.name === 'Aktuell'"
                                :heading="$t('dashboard_heading_metrics')"
                                :size="calculateSize(element.name, false)"
                                :edit-mode="editMode"
                                class="pl-20 pr-6 pt-8 pb-6"
                            />
                            <PriceTargets
                                v-if="element.name === 'Zielzonen'"
                                :heading="$t('dashboard_heading_pricetargets')"
                                :size="calculateSize(element.name, false)"
                                :edit-mode="editMode"
                            />
                            <Portfolio
                                v-if="element.name === 'Trades'"
                                :heading="$t('dashboard_heading_trades')"
                                :size="calculateSize(element.name, false)"
                                :edit-mode="editMode"
                            />
                            <ContentstreamsListV2 v-if="element.name === 'Analysen'"
                                ><div>
                                    <div class="flex bg-white pt-4">
                                        <button
                                            v-if="!editMode"
                                            class="ml-auto flex items-center px-4 py-2 text-dashboard-primary-grey rounded-md hover:bg-gray-200 hover:text-black transition duration-300"
                                            @click="$router.push('dashboard/markets')"
                                        >
                                            <p class="text-xxs">
                                                {{ $t('plain_all') + ' ' + $t('nav_analysis') }}
                                            </p>
                                            <i class="fi fi-rr-arrow-right"></i>
                                        </button>
                                    </div></div
                            ></ContentstreamsListV2>
                            <!--   <ContentstreamsList
                                v-if="element.name === 'Analysen'"
                                :edit-mode="editMode"
                                :heading="$t('plain_analysis_plural')"
                                :header="true"
                                :filter-header="true"
                                :search-header="true"
                                :date-header="true"
                                :size="calculateSize(element.name, false)"
                                class="h-[500px] overflow-hidden"
                            /> -->
                            <Marketing
                                v-if="element.name === 'Marketing'"
                                :heading="$t('dashboard_heading_marketing')"
                                :size="calculateSize(element.name, false)"
                                :edit-mode="editMode"
                            />
                        </li>
                    </template>
                </draggable>
            </div>
        </div>
    </div>
</template>

<script>
import { nextTick, onMounted, ref, watch, watchEffect } from 'vue';
import { useGrid, useScreen } from 'vue-screen';
import draggable from 'vuedraggable';
import { useStore } from 'vuex';
// import ContentstreamsList from '../../components/dashboard/ContentstreamsList.vue';
import ContentstreamsListV2 from '../../components/dashboard/ContentstreamsListV2.vue';
import CurrentPriceTargets from '../../components/priceTargets/CurrentPriceTargets.vue';
import WebinarInfo from './WebinarInfo.vue';

export default {
    components: {
        WebinarInfo,
        CurrentPriceTargets,
        // ContentstreamsList,
        ContentstreamsListV2,
        draggable
    },
    setup() {
        const store = useStore();
        const editMode = ref(false);
        const currentPage = ref('dashboard');
        const leftSection = ref([]);
        const rightSection = ref([]);
        const isDragging = ref(false);
        const leftClass = ref('grid-rows 2xl:col-span-7');
        const rightClass = ref('grid-rows 2xl:col-span-3');
        const gridClass = ref('grid-rows 2xl:grid-cols-10');
        const allInOneList = ref(false);
        const rowLayout = ref(false);
        const editModeId = ref(null);
        const screen = useScreen();
        const grid = useGrid('tailwind');

        const updateRowLayout = () => {
            rowLayout.value = screen.width < 1536; // '2xl' breakpoint in Tailwind is 1536px
        };

        watchEffect(() => {
            updateRowLayout();
        });

        const calculateSize = (name, isLeft) => {
            if (screen.width <= 1000) return 'small';

            if (isLeft) {
                return 'large';
            } else {
                if (rowLayout.value || allInOneList.value) {
                    return 'large';
                }

                return 'small';
            }
        };

        const loadEditModeData = async () => {
            const get = store.dispatch('edit_mode/get', { page: currentPage.value });
            get.then((response) => {
                const customization = response.data.customization;
                leftSection.value = customization.left;
                rightSection.value = customization.right;
                editModeId.value = response.data.id;
            }).catch(() => {
                createEditModeEntry();
            });
        };

        const createEditModeEntry = async () => {
            const data = {
                page: currentPage.value,
                customization: {
                    left: [
                        { id: 1, name: 'Aktuell' },
                        { id: 2, name: 'Zielzonen' },
                        { id: 5, name: 'Marketing' }
                    ],
                    right: [
                        { id: 4, name: 'Analysen' },
                        { id: 3, name: 'Trades' }
                    ]
                }
            };

            const init = store.dispatch('edit_mode/init', data);
            await loadEditModeData();
        };

        const saveEditModeData = async () => {
            const data = {
                page: currentPage.value,
                customization: {
                    left: leftSection.value,
                    right: rightSection.value
                }
            };

            const init = store.dispatch('edit_mode/init', data);
        };

        const onStart = () => {
            isDragging.value = true;
        };

        const onEnd = () => {
            isDragging.value = false;
            saveEditModeData();
        };

        const updateClasses = () => {
            if (leftSection.value.length === 0 || rightSection.value.length === 0) {
                allInOneList.value = true;
                leftClass.value = leftSection.value.length === 0 ? '2xl:col-span-1' : '2xl:col-span-9';
                rightClass.value = rightSection.value.length === 0 ? '2xl:col-span-1' : '2xl:col-span-9';
                gridClass.value = 'grid-rows 2xl:grid-cols-10';
            } else {
                allInOneList.value = false;
                leftClass.value = '2xl:col-span-7 3xl:col-span-7';
                rightClass.value = '2xl:col-span-3 3xl:col-span-3';
                gridClass.value = 'grid-rows 2xl:grid-cols-10';
            }
        };

        watch([leftSection, rightSection], updateClasses);

        onMounted(async () => {
            editMode.value = window.editMode;
            await nextTick();
            await loadEditModeData();
            window.addEventListener('editModeChange', () => {
                editMode.value = window.editMode;
            });
        });

        return {
            screen,
            grid,
            editMode,
            currentPage,
            leftSection,
            rightSection,
            isDragging,
            onStart,
            onEnd,
            leftDraggable: leftClass,
            rightDraggable: rightClass,
            gridClass,
            allInOneList,
            rowLayout,
            calculateSize
        };
    }
};
</script>
